import styled from 'styled-components';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const Animation = styled.div.withConfig({
  displayName: "EPAnimatedSearchBox__Animation",
  componentId: "p0xmk3-0"
})(["animation:appear 300ms ease-out;@keyframes appear{0%{opacity:0;transform:scale(0.95);}100%{opacity:1;transform:scale(1);}}"]);
const EPAnimatedSearchBox = ({
  children
}) => {
  return /*#__PURE__*/_jsx(Animation, {
    children: /*#__PURE__*/_jsx(View, {
      borderRadius: "200",
      boxShadow: "400",
      inlineSize: "580px",
      backgroundColor: "fill-secondary-default",
      overflow: "hidden",
      children: children
    })
  });
};
export default EPAnimatedSearchBox;